import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import ChangePasswordPopUp from "../popup/ChangePasswordPopUp";
import ClientLayout from "../../../components/client/layout/ClientLayout";
import WorkerAmountCard from "../../../components/client/dashboard/WorkerAmountCard";
import styles from "./ClientMainPage.module.css"
import ProjectInfoCard from "../../../components/client/dashboard/ProjectInfoCard";
import ContractInfoCard from "../../../components/client/dashboard/ContractInfoCard";
import BillingInfoCard from "../../../components/client/dashboard/BillingInfoCard";

interface LocationState {
    loginInfo: {
        isFirstTempLogin: boolean;
    };
}

//클라이언트 메인 페이지
const ClientMainPage: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const location = useLocation();

    // 세션 스토리지에서 값을 읽어 상태 초기화
    const [isFirstTempLogin, setIsFirstTempLogin] = useState<boolean>(() => {
        const savedValue = sessionStorage.getItem('isFirstTempLogin');
        return savedValue === 'true';
    });

    useEffect(() => {
        // location state에 값이 있으면 업데이트 (필요한 경우에만)
        if (location.state) {
            const stateIsFirstLogin = (location.state as LocationState)?.loginInfo?.isFirstTempLogin;

            if (stateIsFirstLogin !== undefined) {
                setIsFirstTempLogin(stateIsFirstLogin);
            }
        }
    }, [location.state]);

    useEffect(() => {
        // 임시 비밀번호 발급 후 첫 로그인 시 비밀번호 변경 팝업 출력
        if (isFirstTempLogin) {
            setIsModalOpen(true);
        } else {
            setIsModalOpen(false);
        }
    }, [isFirstTempLogin]);

    const handleCloseModal = () => {
        if (!isFirstTempLogin) {
            setIsModalOpen(false);
        }
    };

    const handlePasswordChangeSuccess = () => {
        // 비밀번호 변경 성공 시 isFirstTempLogin 상태 업데이트
        setIsFirstTempLogin(false);
        sessionStorage.setItem('isFirstTempLogin', 'false');
        setIsModalOpen(false);
    };

    return (
        <ClientLayout
            isFirstTempLogin={isFirstTempLogin}
        >
            {/*비밀번호 변경 팝업*/}
            <ChangePasswordPopUp
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onPasswordChangeSuccess={handlePasswordChangeSuccess}
            />
            <div className={styles.dashboardGrid}>
                <div className={styles.topRow}>
                    {/*작업자 수 카드*/}
                    <WorkerAmountCard onAddClick={() => {}}/>
                    {/*프로젝트 현황 정보 조회 카드*/}
                    <ProjectInfoCard/>
                </div>
                <div className={styles.bottomRow}>
                    {/*계약 정보 카드*/}
                    <ContractInfoCard/>

                    {/* 결제 정보 카드 */}
                    <BillingInfoCard/>
                </div>
            </div>
        </ClientLayout>
    );
};

export default ClientMainPage;